<form [formGroup]="apiKeyForm">
  <h3 class="margin-top">Primary Environment Settings</h3>
  <div>
    Provide the Spot by NetApp account ID and API key that {{ uiService.productName }} should use to query for resources
    in the primary environment.
  </div>
  <div class="margin-left">
    <h4 class="margin-top">Spot by NetApp Account ID</h4>
    <div class="flex-center-row full-width field-issue-container">
      <input
        id="primary-account-id"
        class="arpio-input spacer"
        type="text"
        formControlName="primaryAccountId"
        placeholder='Spot by NetApp account IDs begin with "act-"'
      />
      @if (!!badPrimaryAccountIdPrefix) {
        <arp-field-issue message='Must start with "act-"'></arp-field-issue>
      } @else {
        @if (!!badPrimaryAccountIdLength) {
          <arp-field-issue message="Too long"></arp-field-issue>
        } @else {
          @if (!!badPrimaryAccountIdChars) {
            <arp-field-issue message="Invalid Characters"></arp-field-issue>
          }
        }
      }
    </div>
    <h4 class="margin-top">Permanent Access Token</h4>
    <div class="flex-center-row full-width">
      <input
        id="primary-api-key"
        class="arpio-input spacer"
        type="text"
        formControlName="primaryApiKey"
        placeholder="Generated in Settings &rarr; API in the Spot by NetApp console"
      />
    </div>
  </div>

  <h3 class="double-margin-top">Recovery Environment Settings</h3>
  <div>
    Provide the Spot by NetApp account ID and API key that {{ uiService.productName }} should use to replicate resources
    in the recovery environment.
  </div>
  <div class="margin-left">
    <h4 class="margin-top">Spot by NetApp Account ID</h4>
    <div class="flex-center-row full-width field-issue-container">
      <input
        id="recovery-account-id"
        class="arpio-input spacer"
        type="text"
        formControlName="recoveryAccountId"
        placeholder='Spot by NetApp account IDs begin with "act-"'
      />
      @if (!!badRecoveryAccountIdPrefix) {
        <arp-field-issue message='Must start with "act-"'></arp-field-issue>
      } @else {
        @if (!!badRecoveryAccountIdLength) {
          <arp-field-issue message="Too long"></arp-field-issue>
        } @else {
          @if (!!badRecoveryAccountIdChars) {
            <arp-field-issue message="Invalid Characters"></arp-field-issue>
          }
        }
      }
    </div>
    <h4 class="margin-top">Permanent Access Token</h4>
    <div class="flex-center-row full-width">
      <input
        id="recovery-api-key"
        class="arpio-input spacer"
        type="text"
        formControlName="recoveryApiKey"
        placeholder="Generated in Settings &rarr; API in the Spot by NetApp console"
      />
    </div>
  </div>
</form>
